module.exports = __webpack_public_path__ + "img/VWC.fdfbeeac.svg";